export const PRICE_FIELD_CENTER_VALUE = 500_000;
export const PRICE_FIELD_DEFAULT_MAX = 4_500_000;
export const PRICE_FIELD_MIN = 0;
export const PRICE_FIELD_STEP = 10_000;
export const PRICE_FIELD_CENTER_VALUE = 500_000;
export const PRICE_FIELD_DEFAULT_MAX = 4_500_000;
export const PRICE_FIELD_MIN = 0;
export const PRICE_FIELD_STEP = 10_000;
